import { COOKIE_KEYS } from '~/common/data/cookie-keys.data';
import { ThemeMode } from '~/common/types/theme.type';
import { getCookie, setCookie } from '~/common/utils/cookie.util';

const DARK_CLASS = 'dark';

/**
 * 쿠키에서 저장된 테마 모드 조회
 */
export function getStoredThemeMode(): ThemeMode {
  const savedMode = getCookie(COOKIE_KEYS.THEME_MODE);
  if (savedMode === ThemeMode.DARK || savedMode === ThemeMode.LIGHT) {
    return savedMode as ThemeMode;
  }
  return ThemeMode.LIGHT;
}

/**
 * 테마 모드를 쿠키에 저장
 */
export function saveThemeMode(mode: ThemeMode): void {
  setCookie(COOKIE_KEYS.THEME_MODE, mode, { expires: 365, path: '/' });
}

/**
 * documentElement에 .dark 클래스를 동기화한다. CSS variable 어댑터의 진입점.
 */
export function applyThemeMode(mode: ThemeMode): void {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle(DARK_CLASS, mode === ThemeMode.DARK);
}
